/* tslint:disable */
/* eslint-disable */
/**
 * home-health-api
 * home-health-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { HchbPhysicianSummary } from './HchbPhysicianSummary';
import {
    HchbPhysicianSummaryFromJSON,
    HchbPhysicianSummaryFromJSONTyped,
    HchbPhysicianSummaryToJSON,
} from './HchbPhysicianSummary';

/**
 * 
 * @export
 * @interface HchbPhysicianPage
 */
export interface HchbPhysicianPage {
    /**
     * 
     * @type {Array<HchbPhysicianSummary>}
     * @memberof HchbPhysicianPage
     */
    data: Array<HchbPhysicianSummary>;
    /**
     * 
     * @type {number}
     * @memberof HchbPhysicianPage
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPhysicianPage
     */
    limit: number;
    /**
     * 
     * @type {number}
     * @memberof HchbPhysicianPage
     */
    total: number;
    /**
     * 
     * @type {boolean}
     * @memberof HchbPhysicianPage
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the HchbPhysicianPage interface.
 */
export function instanceOfHchbPhysicianPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "limit" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function HchbPhysicianPageFromJSON(json: any): HchbPhysicianPage {
    return HchbPhysicianPageFromJSONTyped(json, false);
}

export function HchbPhysicianPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): HchbPhysicianPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(HchbPhysicianSummaryFromJSON)),
        'page': json['page'],
        'limit': json['limit'],
        'total': json['total'],
        'has_next': json['has_next'],
    };
}

export function HchbPhysicianPageToJSON(value?: HchbPhysicianPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(HchbPhysicianSummaryToJSON)),
        'page': value.page,
        'limit': value.limit,
        'total': value.total,
        'has_next': value.has_next,
    };
}

